import { JsonItem } from "../../entities/pick-list/pick-list.entities"

import { MultiselectFilter, MultiselectFilterOptions } from "./filter-types/MultiselectFilter";
export {
    MultiselectFilter, MultiselectFilterOptions
}

export interface ITableFilter {
    filterId: string; // ID of HTML Element
    displayName: string; // Displayed above filter
    propertyName: string; // property name of data element (dot notation)

    initialize(items: any[], filterTable: IFilterTable): void;
    generateFilterHtml(): string;
    filterItems(items: any[]): any[];
    getSelected(): string | string[] | number;
    setSelected(selectedValues: string | string[] | number): void;
    resetFilter(): void;
}

export enum FilterDataType {
    String = 1,
    Number = 2,
    PipePathSeparatedIds = 3,
    PipePathSeparatedStrings = 4,
    YesNo = 5,
}

export interface IFilterTable {
    pickLists: JsonItem[]; // pick lists used for the filter
    triggerFilter(): void;
}

export class FilterTab {
    tabId: string; // Used for HTML Generation
    displayName: string; // Tab Name Display
    columnViewName: string; // For associating filter tab with table columns
    filters: ITableFilter[];

    constructor(tabId: string, displayName: string, columnViewName: string, filters: ITableFilter[]) {
        this.tabId = tabId;
        this.displayName = displayName;
        this.columnViewName = columnViewName;
        this.filters = filters;
    }

    generateFilterHtml(): string {
        let filtersContent = "";
        this.filters.forEach(filter => {
            filtersContent += filter.generateFilterHtml();
        });
        return filtersContent;
    }

    getSelectedValues(): any[] {
        let selectedValues = [];
        for (let i = 0; i < this.filters.length; i++) {
            let selected = this.filters[i].getSelected();
            selectedValues.push(selected);
        }
        return selectedValues;
    }
    setSelectedValues(selectedArr: any[]): void {
        for (let i = 0; i < selectedArr.length; i++) {
            let filter = this.filters[i];
            let selected = selectedArr[i];
            filter.setSelected(selected);
        }
    }
}
